import { render, staticRenderFns } from "./OfflineClasses.vue?vue&type=template&id=2e8ff112&scoped=true&"
import script from "./OfflineClasses.vue?vue&type=script&lang=js&"
export * from "./OfflineClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ff112",
  null
  
)

export default component.exports